import { ChatMessageMarkdown } from '@aimsos/ui';

/** Null-safe markdown sub-block for the engine-authored render fields. */
export const HitlMarkdown = ({ content }) => {
  if (!content) return null;
  return <ChatMessageMarkdown content={content} />;
};

/** Small uppercase section label above a render field. */
export const SectionLabel = ({ children }) => (
  <p className="mb-1 text-xs font-semibold uppercase tracking-wide opacity-60">{children}</p>
);

/**
 * "View in My Tasks" host-navigation link. Renders nothing when the host
 * provides no handler (embed-safe — no hardcoded route in the package).
 */
export const OpenTasksLink = ({ onOpenTasks, label }) => {
  if (!onOpenTasks) return null;
  return (
    <button
      type="button"
      onClick={onOpenTasks}
      className="text-left text-xs text-content-secondary underline hover:text-content"
    >
      {label}
    </button>
  );
};
